import { createElement } from 'preact';
export function currencyFormat(source = 0, suffix = "") {
    return new Intl.NumberFormat('ja', { style: 'currency', currency: 'JPY' }).format(source ?? 0) + suffix;
}
export function nl2br(source) {
    let result = source ?? '';
    const regex = /(\r\n|\r|\n)/g;
    return result.split(regex).map((line, index) => {
        if (line.match(regex)) {
            return createElement('br', { key: index });
        }
        return line;
    });
}
